import React from 'react'
import { TrafficData } from '@src/data/UtmGenerator'
import { CheckboxComponent } from '@src/components/UtmGenerator'
import { useHTTPContext } from '@src/containers/UtmGenerator/context'

import * as Styled from './ListCheckbox.styled'

function ListCheckbox() {
  const { traffic, getSourceTraffic } = useHTTPContext()

  return (
    <Styled.Row>
      {TrafficData.map(item => (
        <CheckboxComponent
          key={item.id}
          text={item.text}
          name={item.name}
          checked={traffic === item.name}
          onChange={getSourceTraffic as () => {}}
        />
      ))}
    </Styled.Row>
  )
}

export default ListCheckbox
